import Vue from 'vue'
import App from './App.vue'
import { Toast, Notify, Dialog } from 'vant'

import '@/assets/style/reset.less'
import 'vant/lib/index.css'

Vue.use(Toast).use(Notify).use(Dialog)
Vue.config.productionTip = false

new Vue({
  render: (h) => h(App),
}).$mount('#app')
